<script>
import Area from '../../js/dto/resource/Area';
import Field from '../../js/dto/resource/Field';

const DEFAULT_LOCATION_IMAGE_URL = '/img/resource/location/default.png';
const DEFAULT_AREA_IMAGE_URL = '/img/resource/area/default.png';
const DEFAULT_FIELD_IMAGE_URL = '/img/resource/field/default.png';

export default {
    methods: {
        urlForListThumb(tile, force = false) {
            if (tile instanceof Area) {
                return (force || tile.hasImage) ? `${tile.imageUrl}?size=list_thumb` : DEFAULT_AREA_IMAGE_URL;
            }

            if (tile instanceof Field) {
                return (force || tile.hasImage) ? `${tile.imageUrl}?size=list_thumb` : DEFAULT_FIELD_IMAGE_URL;
            }

            return (force || tile.hasImage) ? `${tile.imageUrl}?size=list_thumb` : DEFAULT_LOCATION_IMAGE_URL;
        },
        urlForEdit(tile) {
            if (tile instanceof Area) {
                return this.urlForAreaEdit(tile.locationId, tile.id);
            }

            if (tile instanceof Field) {
                return this.urlForFieldEdit(tile.locationId, tile.areaId, tile.id);
            }

            return this.urlForLocationEdit(tile.id);
        },
        urlForLocationEdit(locationId) {
            return `/backend/resources/locations/${locationId}/edit`;
        },
        urlForAreaEdit(locationId, areaId) {
            return `/backend/resources/locations/${locationId}/areas/${areaId}/edit`;
        },
        urlForFieldEdit(locationId, areaId, fieldId) {
            return `/backend/resources/locations/${locationId}/areas/${areaId}/fields/${fieldId}/edit`;
        },
    },
};
</script>
